<div class="element-messages" [class.visibility-hidden]="!expanded">
  <div class="element-messages__top">
    <div class="element-messages__top__left">
      Dynamic Notifications
    </div>

    <div class="element-messages__top__right">
      <app-button (clicked)="addClick.emit()" text="+ Add Notification" variant="info" size="sm"></app-button>
      <app-button (clicked)="closed.emit()" faIcon="far fa-times" [iconOnly]="true" variant="secondary" size="sm"></app-button>
    </div>
  </div>

  @if (messages.length === 0) {
    <app-element-message text="No notifications added yet"></app-element-message>
  }

  @for (message of messages; track message.id; let i = $index) {
    <app-element-message
      [text]="getMessageText(message)"
      [variant]="getMessageVariant(message)"
      [active]="message.active"
      (editClick)="editClick.emit(i)"
      (removeClick)="removeClick.emit(i)">
    </app-element-message>
  }
</div>
